module.exports = __webpack_public_path__ + "static/img/performance03.733a7ab8.jpg";